import axios from 'axios';

export const postFicheParametrage = async (parametrage) => {
    return await axios.post(`/arretTravail/parametrage`, parametrage);
};

export const postWorkStoppage = async (parametrage) => {
    return await axios.post('/workstoppage', parametrage);
};

export const getRematerialization = (store) => {
    const formDatas = { ...store };
    populateSalaryBaseS3201WithInetrruption(formDatas);
    return axios.post('/rematerialization', formDatas, {
        responseType: 'blob',
    });
};

export const getRematerializationRCSS = (store) => {
    const formDatas = { ...store };
    populateSalaryBaseS3201WithInetrruption(formDatas);
    return axios.post('/rematerialization_RCSS', formDatas, {
        responseType: 'blob',
    });
};

export const getWorkStoppageCompagnie = ({ idContract, startDate }) => {
    return axios.post('/workstoppage/compagnie', { idContract, startDate });
};

/**
 * Populate salaryBaseS3201 with interruptionActivityS3201
 * @param formDatas
 */
export const populateSalaryBaseS3201WithInetrruption = (formDatas) => {
    if (formDatas?.interruptionActivityS3201) {
        formDatas.interruptionActivityS3201.forEach((interruptionActivity) => {
            if (interruptionActivity.period) {
                const salaryBase = formDatas.salaryBaseS3201.find((entry) => entry.id === interruptionActivity.period);

                if (salaryBase) {
                    salaryBase.interruptionActivityS3201 = interruptionActivity;
                }
            }
        });

        delete formDatas.interruptionActivityS3201;
    }
};

export const saveEtablissement = (etablissement) => {
    if (etablissement.id) return axios.put('/arret_travail/etablissements/' + etablissement.id, etablissement);
    return axios.post('/arret_travail/etablissements', etablissement);
};

export function getEtablissements(page, limit, sort, search, siren) {
    return axios.get(`arret_travail/etablissements/${siren}`, {
        params: {
            page,
            limit,
            sort,
            search: search && search.length ? JSON.stringify(search) : undefined,
        },
    });
}
